export default "7,1\n11,1\n11,7\n9,7\n9,5\n2,5\n2,3\n7,3"